import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const WireLessAccessPointNew = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.244 15.048h2.795l12.875.017c.307-.099.408-.308.42-.4v-3.402a.45.45 0 0 0-.385-.424L2.086 10.82a.51.51 0 0 0-.419.495v3.219c-.014.396.379.507.577.513"
            fill="url(#a)"
          />
          <path
            d="M5.074 12.623c0-.097.078-.175.174-.175h9.539c.096 0 .175.078.175.175v2.407H5.074z"
            fill="#5E5B5B"
          />
          <rect
            x="7.1"
            y="13.438"
            width=".559"
            height=".566"
            rx=".28"
            fill="#6FC869"
          />
          <g filter="url(#b)">
            <rect
              x="7.1"
              y="13.438"
              width=".559"
              height=".566"
              rx=".28"
              fill="#00D247"
            />
          </g>
          <rect
            x="8.148"
            y="13.438"
            width=".559"
            height=".566"
            rx=".28"
            fill="#6FC869"
          />
          <g filter="url(#c)">
            <rect
              x="8.148"
              y="13.438"
              width=".559"
              height=".566"
              rx=".28"
              fill="#00D247"
            />
          </g>
          <rect
            x="9.197"
            y="13.438"
            width=".559"
            height=".566"
            rx=".28"
            fill="#6FC869"
          />
          <g filter="url(#d)">
            <rect
              x="9.197"
              y="13.438"
              width=".559"
              height=".566"
              rx=".28"
              fill="#00D247"
            />
          </g>
          <rect
            x="10.245"
            y="13.438"
            width=".559"
            height=".566"
            rx=".28"
            fill="#6FC869"
          />
          <g filter="url(#e)">
            <rect
              x="10.245"
              y="13.438"
              width=".559"
              height=".566"
              rx=".28"
              fill="#00D247"
            />
          </g>
          <rect
            x="11.293"
            y="13.438"
            width=".559"
            height=".566"
            rx=".28"
            fill="#6FC869"
          />
          <g filter="url(#f)">
            <rect
              x="11.293"
              y="13.438"
              width=".559"
              height=".566"
              rx=".28"
              fill="#00D247"
            />
          </g>
          <rect
            x="12.341"
            y="13.438"
            width=".559"
            height=".566"
            rx=".28"
            fill="#6FC869"
          />
          <g filter="url(#g)">
            <rect
              x="12.341"
              y="13.438"
              width=".559"
              height=".566"
              rx=".28"
              fill="#00D247"
            />
          </g>
          <rect
            x="2.977"
            y="12.377"
            width="1.083"
            height="1.061"
            rx=".07"
            fill="#404040"
          />
          <path
            fill="#5E5B5B"
            d="M3.239 15.065h1.852v.601H3.239zm11.67 0h1.852v.601h-1.852z"
          />
          <rect
            x="15.975"
            y="12.413"
            width="1.083"
            height="1.061"
            rx=".07"
            fill="#404040"
          />
          <path
            d="M2.977 5.208a.542.542 0 0 1 1.083 0v5.613H2.977zm12.998 0a.542.542 0 0 1 1.083 0v5.613h-1.083z"
            fill="#404040"
          />
          <defs>
            <filter
              id="b"
              x="6.767"
              y="13.105"
              width="1.226"
              height="1.233"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation=".167"
                result="effect1_foregroundBlur_682_74303"
              />
            </filter>
            <filter
              id="c"
              x="7.815"
              y="13.105"
              width="1.226"
              height="1.233"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation=".167"
                result="effect1_foregroundBlur_682_74303"
              />
            </filter>
            <filter
              id="d"
              x="8.863"
              y="13.105"
              width="1.226"
              height="1.233"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation=".167"
                result="effect1_foregroundBlur_682_74303"
              />
            </filter>
            <filter
              id="e"
              x="9.911"
              y="13.105"
              width="1.226"
              height="1.233"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation=".167"
                result="effect1_foregroundBlur_682_74303"
              />
            </filter>
            <filter
              id="f"
              x="10.96"
              y="13.105"
              width="1.226"
              height="1.233"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation=".167"
                result="effect1_foregroundBlur_682_74303"
              />
            </filter>
            <filter
              id="g"
              x="12.008"
              y="13.105"
              width="1.226"
              height="1.233"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation=".167"
                result="effect1_foregroundBlur_682_74303"
              />
            </filter>
            <linearGradient
              id="a"
              x1="10"
              y1="10.821"
              x2="10"
              y2="15.065"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F2F2F2" />
              <stop offset=".54" stop-color="#EBEDEC" />
              <stop offset="1" stop-color="#DBDBDB" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default WireLessAccessPointNew;
